import React from 'react'
import chunk from 'lodash/chunk'
import Photo from './Photo'

const MediaGrid = ({clickHandler, columnCount, mediaArray}) => {
  const rows = chunk(mediaArray, columnCount)
  
  const grid = rows.map((row, index) => {
    return (
      <div key={index} id={index} className='row'>
        {
          row.map((url, rowIndex) => {
            const indexInCollection = index*columnCount + rowIndex
            return (
              <Photo
                key={url}
                src={url}
                clickHandler={()=>clickHandler(indexInCollection)} 
              />
            )
          })
        }
      </div>
    )
  })
  
  return (
    <div className="imageGrid">
      {grid}
    </div>
  )
}

export default MediaGrid



// WEBPACK FOOTER //
// ./src/components/Outreach/MediaGrid.js